import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function RegistroDeliveryView() {
  const [nombre, setNombre] = useState('');
  const [correo, setCorreo] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();

  const handleRegistro = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');

    if (!nombre || !correo || !contrasena) {
      setError('Todos los campos son obligatorios');
      return;
    }

    try {
      const response = await fetch('http://localhost:5000/api/delivery-user/registro', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombre, correo, contrasena })
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error al registrar delivery');
        return;
      }

      setMensaje('Usuario delivery registrado exitosamente');
      setNombre('');
      setCorreo('');
      setContrasena('');

      // Opcional: redirigir automáticamente al login de delivery
      setTimeout(() => navigate('/login-delivery'), 1500);

    } catch (err) {
      console.error(err);
      setError('Error de conexión con el servidor');
    }
  };

  return (
    <div style={containerStyle}>
      <div style={formBoxStyle}>
        <h2 style={titleStyle}>Registro Delivery</h2>
        <form onSubmit={handleRegistro}>
          <input
            type="text"
            placeholder="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            style={inputStyle}
          />
          <input
            type="email"
            placeholder="Correo"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            style={inputStyle}
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={contrasena}
            onChange={(e) => setContrasena(e.target.value)}
            style={inputStyle}
          />
          <button type="submit" style={buttonStyle}>Registrar</button>
        </form>
        {error && <p style={{ color: '#ff4d4d', marginTop: '10px' }}>{error}</p>}
        {mensaje && <p style={{ color: '#4caf50', marginTop: '10px' }}>{mensaje}</p>}
      </div>
    </div>
  );
}

const containerStyle = {
  backgroundColor: '#000',
  color: '#fff',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Arial, sans-serif'
};

const formBoxStyle = {
  backgroundColor: '#111',
  padding: '40px',
  borderRadius: '8px',
  boxShadow: '0 0 10px rgba(255, 0, 0, 0.5)',
  width: '100%',
  maxWidth: '400px'
};

const titleStyle = {
  color: '#ff0000',
  textAlign: 'center',
  marginBottom: '30px'
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  marginBottom: '15px',
  borderRadius: '4px',
  border: '1px solid #444',
  backgroundColor: '#222',
  color: '#fff',
  fontSize: '14px'
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#ff0000',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  fontSize: '16px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease'
};

export default RegistroDeliveryView;
